export default __webpack_public_path__ + "b34f7ac054c39ea639565a7dd843a971.jpg";